module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag12_0605AT.72fcc47e.jpg";